

import { getDateByTimeZoneOffset, monthName } from '@common/dateTimeHelper';
import {Component, Prop, Vue} from 'vue-property-decorator';
import { Element } from "@api/models/Element"

import FavoritesSwitcher from "@share/common/favorites-switcher/FavoritesSwitcher.vue";
import { DateTime } from 'luxon';
import { RootState } from '@service/store/types/RootState';

@Component({
    components: {FavoritesSwitcher }
})
export default class TimeCardTopBase extends Vue {

    @Prop({ required: true }) source: Element;

    readonly base_class ="time-card-top";
    readonly date_class ="time-card-top__date";
    readonly right_class ="time-card-top__right";
    readonly center_class ="time-card-top__center";

    get lang() {
        return this.$store.state.session?.language || navigator.language.split('-')[0] || "en";
    }

    get selectedTzOffset() {
        return (this.$store.state as RootState).selectedTimeZoneOffset;
    }

    get day() {
        return getDateByTimeZoneOffset(this.source.beginAt, this.selectedTzOffset).day;
    }

    get month() {
        const date = getDateByTimeZoneOffset(this.source.beginAt, this.selectedTzOffset);
        return this.lang === 'en' ? monthName(date.month, this.lang) : monthName(date.month, this.lang).toLowerCase()
    }

    get year() {
        const begin = getDateByTimeZoneOffset(this.source.beginAt, this.selectedTzOffset);
        return begin.plus({ years: 1 }) < DateTime.local() ? begin.year : "";
    }
}

